module.exports = __webpack_public_path__ + "media/images/tips-84c9b00ccb3db7213dc6629ace6adcff.png";